<template>
  <b-container fluid>
    <b-row class="sla_row">
      <b-col cols="12">
        <b-form inline>
          <b-input-group :prepend="$t('product-overview.sla.qty')" class="caption">
            <b-form-input id="slaMenge" type="number" v-model="menge" :state="mengeState" @keydown.enter.prevent="calcSLA" />
          </b-input-group>

          <b-button variant="primary" v-on:click="calcSLA()" style="margin-left:5px"><b-icon-arrow-clockwise/> {{ $t('product-overview.sla.calc') }}</b-button>
        </b-form>
      </b-col>
    </b-row>
    <b-row  class="sla_row text_row" v-if="sla.berechnungsStopp === false ">
      <b-col cols="4">{{ $t('product-overview.sla.qty') }}</b-col><b-col cols="8">{{sla.menge}}</b-col>
      <b-col cols="4">{{ $t('product-overview.sla.workingDays') }}</b-col><b-col cols="8">{{sla.werktage}}</b-col>
      <b-col cols="4">{{ $t('product-overview.sla.week') }}</b-col><b-col cols="8">{{sla.lieferKw}}/{{sla.lieferKwJahr}}</b-col>
      <b-col cols="4">{{ $t('product-overview.sla.date') }}</b-col><b-col cols="8">{{formatDateLocal(sla.lieferDatum)}}</b-col>
    </b-row>
    <b-row  class="sla_row text_row" v-if="sla.berechnungsStopp === true">
      <b-col cols="12">{{ $t('product-overview.sla.notPossible') }}</b-col>
    </b-row>
    <b-row class="sla_row text_row" v-if="sla.berechnungsStopp === false">
      <b-col cols="12">
        {{ $t('product-overview.sla.hint') }}
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import formatDate from "@/mixins/formatDate";

export default {


  name: 'SLA',
  props: ['konfigModel', 'csrfToken'],
  mixins: [formatDate],
  data: function () {
    return {
      menge: 1,
    }
  },
  computed: {
    mengeState: function ()  {
      return this.menge > 0;
    },
    sla: function () {
      if (this.$store.getters.sla) {
        return this.$store.getters.sla;
      } else {
        return {
          berechnungsStopp: null
        }
      }

    }

  },
  methods: {
    calcSLA() {
      this.$store.dispatch('calcSLA', {menge: this.menge})
    },
    formatDateLocal(d) {
      return this.formatDate(d)
    }
  },
  beforeCreate() {
    this.$store.commit('resetSla')
  },
  created() {
    this.calcSLA();
  }
}
</script>

<style scoped>

.caption > div > div {
  font-size: 14px;
}

.sla_row {
  margin-top: 20px;
}
.text_row {
  padding-left: 2px;
}
</style>